<template>
  <!-- 发票详情 -->
  <el-card shadow="never" class="create_card">
    <div slot="header" class="clearfix">
      <el-button type="text" class="backBtn" @click="changeBack"> 返回</el-button>
      <span class="font18">发票详情</span>
      <span
        type="text"
        style="float: right;font-size: 16px"
      >{{dictFilter(info.invoiceStatus, 'myInvoiceStatus')}}</span>
    </div>
    <div >
    <div class="descicon"></div>
    <span class="font16">开票结果</span>
    <div
      class="nodata"
      v-if="!info.invoiceResultVOS || info.invoiceResultVOS.length == 0"
    >暂无开票结果信息</div>
    <div v-else>
      <div class="goods_info" v-for="(item,index) in info.invoiceResultVOS" :key="item.index">
        <div class="goods_info_list">发票{{index + 1}}</div>
        <el-descriptions class="margin-top" :column="2" border>
          <el-descriptions-item label="开票金额(元)">¥{{item.invoiceMoney}}</el-descriptions-item>
          <el-descriptions-item label="发票号">{{item.invoiceCode}}</el-descriptions-item>
          <el-descriptions-item label="开票日期">{{item.invoiceDate}}</el-descriptions-item>
          <el-descriptions-item label="发票附件">
            <el-button type="text" @click="fileHandle(item.invoiceFileList)">附件下载</el-button>
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>
    <div style="margin-top: 20px">
      <div class="descicon" ></div>
        <span class="font16">报账材料</span>
        <div class="formItem">
          <div class="formItem_label">报账材料:</div>
          <div class="formItem_content">
            <div
              v-if="!info.accountingInformationList || info.accountingInformationList.length == 0"
            >暂无</div>
            <el-button v-else type="text" @click="fileHandle(info.accountingInformationList)">附件下载</el-button>
          </div>
        </div>
      </div>
    </div>
    <detailsCommon :boxList="boxList" :form="info" :pageId="'invoiceItem'" :labelPosition="'rihgt'"></detailsCommon>
    <div style="margin-top: 20px">
      <div class="descicon"></div>
      <span class="font16">打款凭证</span>
      <div class="formItem">
        <div class="formItem_label">打款凭证:</div>
        <div class="formItem_content">
          <div v-if="!info.uploadPaymentVoucherList || info.uploadPaymentVoucherList.length == 0">暂无</div>
          <el-button v-else type="text" @click="fileHandle(info.uploadPaymentVoucherList)">附件下载</el-button>
        </div>
      </div>
    </div>
    <div style="margin-top: 20px">
      <div class="descicon"></div>
      <span class="font16">开票记录</span>
      <div class="formItem">
        <el-timeline :reverse="false" class="timelineWrapper">
        <el-timeline-item
        v-for="(activity, index) in logsList"
        :key="index"
        color="#0bbd87"
        :timestamp="activity.addTime">
        {{activity.context}}
        </el-timeline-item>
    </el-timeline>
      </div>
    </div>
  </el-card>
</template>
<script>
import detailsCommon from "./detailsCommon";
import { invoiceInfo ,getInvoiceApplyLogList } from "@/api/request";
export default {
  components: { detailsCommon },
  data() {
    return {
      info: {},
      logsList: [],
      groups: [{}, {}]
    };
  },
  computed: {
    boxList() {
      return [
        {
          isDesc: true,
          descTitle: "开票信息",
          formItem: [
            { label: "发票类型:", prop: "invoiceType", span: 12 },
            { label: "开票金额(元):", prop: "invoiceAmount", span: 12 },
            { label: "需报账资料:", prop: "accountingInformation", span: 12 },
            { label: "其他:", prop: "otherInformation", span: 12 },
            { label: "开票备注:", prop: "remark", span: 12 }
          ]
        },
        {
          isDesc: true,
          descTitle: "发票抬头及地址",
          formItem: [
            { label: "发票抬头:", prop: "invoiceTitle", span: 12 },
            { label: "企业税号:", prop: "enterpriseTaxNumber", span: 12 },
            { label: "开户行名称:", prop: "openBankName", span: 12 },
            { label: "开户行账户:", prop: "openBankAccount", span: 12 },
            { label: "注册地址:", prop: "registeredAddress", span: 12 },
            { label: "注册电话:", prop: "registeredTelephone", span: 12 },
            { label: "收件人姓名:", prop: "addressee", span: 12 },
            { label: "收件地址:", prop: "deliveryAddress", span: 12 },
            { label: "收件邮箱:", prop: "receivingContact", span: 12 },
            {
              label: "收件联系方式:",
              prop: "receivingContactInformation",
              span: 12
            }
          ]
        }
      ];
    }
  },
  methods: {
    init(row) {
      invoiceInfo(row.invoiceId).then(res => {
        this.info = {
          ...res.data,
          invoiceType: this.dictFilter(res.data.invoiceType, "invoiceType"),
          invoiceAmount: "¥" + res.data.invoiceAmount,
        };
      });
      getInvoiceApplyLogList(row.invoiceId).then(res => {
        const dayjs = require("dayjs");
        this.logsList = res.rows
        this.logsList.map(item => {
          item.addTime = dayjs(item.addTime).format('YYYY/MM/DD HH:mm:ss') 
        })
      })
    },
    fileHandle(list) {
      if (list.length > 0) {
        let obj = {
          businessName: "发票数据",
          businessIds: list.map(item => item.fileId).toString(),
          businessType: 2
        };
        this.$download.getDownLoadXls(
          "/file/communal/download/fileZipDownload",
          obj
        );
      }
    },
    changeBack() {
      this.$emit("back");
    }
  }
};
</script>
<style scoped>
.goods_info_list {
  line-height: 50px;
  font-size: 14px;
  font-weight: 500;
}
.timelineWrapper{
  padding: 20px 0;
}
</style>